import { render, staticRenderFns } from "./ModalRatingDetail.vue?vue&type=template&id=23521252"
import script from "./ModalRatingDetail.vue?vue&type=script&lang=js"
export * from "./ModalRatingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports